import styled, { css } from 'styled-components';
import { variables } from '@splunk/themes';
import {
    HEADER_AREA,
    type IntrinsicAttributes,
    type ShowBorderProp,
} from './constants';

export const SidebarContentHeader = styled.div.attrs<IntrinsicAttributes>(
    (props) => ({ 'data-test': props['data-test'] ?? 'sidebar-header' })
)<ShowBorderProp>`
    grid-area: ${HEADER_AREA};

    ${(props) =>
        props.$showBorder &&
        css`
            border-bottom: 1px solid ${variables.borderColorStrong};
        `}
`;
